import { useRef, useState } from "react";
import FiltersPopup from "./FiltersPopup";
import { useFormType } from "../../../form/hooks/useForm";
import { EntityConfig, PropConfig } from "../../../types/EntityConfig";
import SearchIcon from '@mui/icons-material/Search';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ClearIcon from '@mui/icons-material/Clear';
// import { useOutsideAlerter } from "../../../hooks/outsideClickHook";



export function FiltersComponent({ filterForm, filterConfigs, hideFilters }: { filterForm: useFormType, filterConfigs: EntityConfig, hideFilters?: boolean }) {

    const [filterIsOpen, setFilterIsOpen] = useState<boolean>(false);

    const filtersRef = useRef(null);



    const activeFilters = (): any[] => {
        const entries = Object.entries(filterForm.state).filter(([k,v] : [k: string, v: any]) => (v!= undefined && v!= null) || v?.length > 0)
        return entries;
    }

    const displayActiveFilters = () => {
        return (<>
            {activeFilters().map((af: any) => {
                const config : PropConfig = filterConfigs[filterConfigs.findIndex((conf: PropConfig) => conf.id === af[0])];
                const label = config.label;
                const valueLabel = config?.options?.label;
                let value = af[1] === true || af[1] === false ? (af[1] === true ? 'Sim' : 'Não') : af[1];
                if(valueLabel) {
                    value = af[1][valueLabel] ? af[1][valueLabel] : af[1];
                } 
                return <span className="mr-4"><span className="font-bold">{label}:</span> {value} <span className="text-lg"><ClearIcon onClick={()=> filterForm.update(null, af[0])} className="cursor-pointer"/></span></span> 
            })}

            <div 
                className="ml-3 mb-2 text-center p-1 rounded-md bg-zinc-400 w-24 cursor-pointer hover:bg-zinc-100"
                onClick={()=> filterForm.init()}    
            >Limpar tudo</div>
        </>)
        

    }

    return (<>
        {!hideFilters ? <div className="flex">
            <div className="flex w-full ">
                <div className="bg-zinc-300 rounded-md text-sm">

                    {filterIsOpen ?
                        <VisibilityOffIcon className="text-rodrimaq-red cursor-pointer hover:animate-bounce m-3"  onClick={() => setFilterIsOpen(false)}/>
                        : <SearchIcon className="text-rodrimaq-red cursor-pointer hover:animate-bounce m-3" onClick={() => setFilterIsOpen(true)} />}

                    {!filterIsOpen ? <>{activeFilters().length == 0 ? <span className="pr-3">Nenhum filtro aplicado</span> : displayActiveFilters()}</> : null}
                    
                </div>
            </div>

            <div className="absolute ml-16 z-50 w-1/3" ref={filtersRef}>
                    <FiltersPopup
                        isOpen={filterIsOpen}
                        headCells={filterConfigs}
                        filterForm={filterForm}
                    />
            </div>
        </div> : null}
    </>
    )



}